import useEditShopContext from 'contexts/shop.context';
import PolygonCard from 'components/shop-polygon-card/index';
import React from 'react';

const PreviewShopPolygon = () => {
  const { polygons } = useEditShopContext();

  const setActivePolygon = () => {
    return;
  };
  return (
    <section className={`space-y-8 $`}>
      <div className='flex justify-between'></div>
      <div className='flex flex-col gap-6 sm:justify-center sm:flex-row'>
        {polygons?.length > 0 && (
          <div className='flex-1'>
            <PolygonCard list={[]} polygons={polygons} setActivePolygon={setActivePolygon} />
          </div>
        )}
      </div>
    </section>
  );
};

export default PreviewShopPolygon;
